import 'core-js'
import 'regenerator-runtime/runtime'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { i18nClient, getCacheLocale } from '@sailor/i18n-web'
import ChainedBackend from 'i18next-chained-backend'
import OpenAPIBackend from '@sailor/i18n-web-openapi-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import resources from './locales/resources'
import Root from './Root'
import { isProd } from '@RootCommon/utils'
import locale from '@roo/roo/locale'
import ar from '@roo/roo/locale/lang/ar'
import en from '@roo/roo/locale/lang/en-US'
import locale_plus from '@roo/roo-plus/locale'
import ar_plus from '@roo/roo-plus/locale/lang/ar'
import en_plus from '@roo/roo-plus/locale/lang/en-US'
import { configResponsive } from '@RootCommon/utils/h5PC'
import responsiveConfig from './common/constants/mediaBreakPoint.json'
import dayjs from 'dayjs'
import i18nConfig from '../.i18n.config.json'
import { languageOptionsList } from '@RootCommon/constants'
import { getQueryValues, setLocaleInfo } from '@RootCommon/utils'
import '@roo/roo/theme/default/index.css'
import '@roo/roo-plus/theme/default/index.css'

const i18nEnv = isProd() ? 'prod' : 'test'
const rooLocaleLangs = {
  ar: ar,
  en: en,
}
const rooPlusLocaleLangs = {
  ar: ar_plus,
  en: en_plus,
}
configResponsive(responsiveConfig)

let defaultLang = ''
if (getQueryValues('locale')) {
  defaultLang = getQueryValues('locale')
} else if (getCacheLocale()) {
  defaultLang = getCacheLocale()
  // @ts-ignore
} else if (navigator.language || navigator.browserLanguage) {
  // @ts-ignore
  defaultLang = navigator.language || navigator.browserLanguage
}

const matched = (languageOptionsList || []).find(item => item.locale === defaultLang) || languageOptionsList[0]
defaultLang = matched.locale

setLocaleInfo(matched)
try {
  if (/^(ar|fa|ur|he)/.test(defaultLang)) document?.documentElement?.setAttribute('dir', 'rtl')
} catch (error) {}

dayjs.locale(defaultLang) // dayjs的语言名可能不一致
i18nClient.use(ChainedBackend).init({
  // 设置回退语言
  fallbackLng: defaultLang,
  supportedLngs: (languageOptionsList || []).map(item => item.locale),
  ns: i18nConfig.namespaces.map((v: any) => v.name), // 当使用多个空间名称时，必须配置 ns，且第一个为默认空间名
  defaultNS: i18nConfig.namespaces.map((v: any) => v.name)[0], // 设置默认空间名称
  backend: {
    backends: [
      OpenAPIBackend, // 通过api获取最新语言包
      resourcesToBackend(resources), // 本地资源包作为兜底
    ],
    // 这里配置一下所使用的projectId和namespaceId
    backendOptions: [{ ...i18nConfig, env: i18nEnv }],
  },
}, function () {
  // 回调中初始化App，并配合lazy的模块才能使用ReactNode外的i18n常量
  locale.use(rooLocaleLangs[defaultLang])
  locale_plus.use(rooPlusLocaleLangs[defaultLang])
  // TODO: StrictMode严格模式为其后代元素触发额外的检查和报告,
  // 在开发过程中组件会有多次调用问题，但仅在开发环境中运行，不会影响生产构建
  createRoot(document.getElementById('root') as HTMLElement).render(<Root />)
})
